import { render } from "./SessionCheckIn.vue?vue&type=template&id=12504d3b&scoped=true&ts=true"
import script from "./SessionCheckIn.vue?vue&type=script&lang=ts"
export * from "./SessionCheckIn.vue?vue&type=script&lang=ts"

import "./SessionCheckIn.vue?vue&type=style&index=0&id=12504d3b&scoped=true&lang=css"

import exportComponent from "D:\\Ventla Code\\New Admin\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-12504d3b"]])

export default __exports__